export const LOGIN_TYPE = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER'
}

export const ORDER_STATUS = ['', '待支付', '已支付', '已超时', '已退款', '兑换码兑换', '已取消', '已转班', '退款中']

export const STATE_MAP = {
  INITIAL_STATE: 0,
  NOT_PAY: 1,
  HAS_PAYED: 2,
  TIMEOUT: 3,
  HAS_REFUNDED: 4,
  PAY_BY_COUPON: 5,
  HAS_CANCELED: 6,
  HAS_TRANSFERED: 7,
  PENDING: 8
}

export const productTypeMap = {
  ONLINE_CLASS: 1,
  BIGLIVE_CLASS: 2,
  SUBLIVE_CLASS: 3,
  QUARK: 4,
  OFFLINE_CLASS: 5,
  VARIOUS_LIVE_CLASS: 7,
  ONLINE_CLASS_BOARDING: 9,
  MULTI_ORDER: 10,
  ZXB: 11,
  PROTON_RECHARGE: 12,
  SVIP: 15
}

export const STATES = {
  KAITUAN: 1,
  PINTUAN_SUCCESS: 2,
  PINTUAN_FAIL: 3
}

export const GROUP_ACTIVITY = {
  GROUP: 1,
  LIAN_BAO: 2
}

export const MOD_SHARE_KEY = 'c7ebab27b974'

export const stateMap = {
  INITIAL_STATE: '0',
  NOTPAY: '1',
  HASPAYED: '2',
  TIMEOUT: '3',
  HASREFUNDED: '4',
  PAYBYCOUPON: '5',
  HASCANCELED: '6',
  HASTRANSFERED: '7',
  PENDING: '8'
}

export const UnionType = {
  99: '联报活动',
  1: '多学科联报',
  2: '暑秋联报',
  3: '寒春联报',
  4: '秋寒春联报',
  5: '春暑秋联报',
  6: '多学科暑秋联报',
  7: '多学科寒春联报',
  8: '多学科秋寒春联报',
  9: '多学科春暑秋联报'
}
